import { render } from "./login-passport.vue?vue&type=template&id=694def38"
import script from "./login-passport.vue?vue&type=script&lang=js"
export * from "./login-passport.vue?vue&type=script&lang=js"
script.render = render

export default script